import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { APIClient } from '../../client';
import {
  Button, Input, Select
} from '../../components/basic-inputs';
import { ErrorMessage } from '../../components/v2/error-message';
import { LifeSaverForm } from '../../components/v2/life-saver-form';

const categories = [
  { id: 'heart-health', label: 'Heart Health' },
  { id: 'meditation', label: 'Meditation' },
  { id: 'spirituality', label: 'Spirituality' },
  { id: 'brain-health', label: 'Brain Health' },
  { id: 'weight', label: 'Weight' },
  { id: 'exercise', label: 'Exercise' },
  { id: 'gastritis', label: 'Gastritis' },
  { id: 'near-death-experience', label: 'Near Death Experience' },
  { id: 'fasting', label: 'Fasting' },
  { id: 'dr-berg', label: 'Dr Berg' },
  { id: 'dr-ekberg', label: 'Dr Ekberg' },
  { id: 'dr-ford', label: 'Dr Ford' },
  { id: 'sleep', label: 'Sleep' },
];

export function NewVideoPage() {
  const navigate = useNavigate();
  const [ selectedCategory, setSelectedCategory ] = useState<{ id: string; label: string } | null>(null);
  const [ error, setError ] = useState('');
  
  const handleCreate = useCallback(async () => {
    const payload = {} as Record<string, string>;

    payload.link = (document.getElementById('link') as HTMLInputElement).value;
    payload.category = selectedCategory?.id;
    // payload.description = (document.getElementById('description') as HTMLInputElement).value;
    // payload.tags = (document.getElementById('tags') as HTMLInputElement).value;

    if (!payload.link) {
      return setError('YouTube Link is required');
    }

    if (!selectedCategory) {
      return setError('Category is required');
    }

    const client = new APIClient('api/videos');
    const json = await client.create(payload);

    console.log('created video', json);

    navigate(`/wellness/videos/${json.id}`);
  }, [ navigate, selectedCategory ]);

  const handleChange = useCallback((option) => {
    console.log('handleChange', option);

    setSelectedCategory(option);
  }, []);

  return (
    <div className="new-video-page screen">
      <LifeSaverForm icon="video_library" header="Video Information">
        <Input id="link" label="YouTube Link" required />
        {/* <Input id="description" label="Description" required />
        <Input id="tags" label="Tags" required /> */}
        <Select 
          id="category" 
          label="Category" 
          options={categories} 
          required 
          handleChange={handleChange} 
          selectedOption={selectedCategory}
        />
        <br />
        <ErrorMessage message={error} />
        <Button fullWidth onClick={handleCreate}>Create</Button>
      </LifeSaverForm>
    </div>
  );
}